import api, { fetchData } from "./api";
import Paginacao from '../types/paginacao';
import Destination from "../types/destination";

export interface DestinationApiResponse {
    data: Destination;
    messages: any; 
}

export const getDestinationsPaginated = async (
    paginacao: Paginacao
  ) => {
    try {
      const endpoint: string = '/Destination/all/paginado';
      const params: Record<string, any> = {
        pageNum: paginacao.pageNum + 1,
        quantityPerPage: paginacao.quantityPerPage,
      };
  
      const response = await fetchData<Destination>(endpoint, params);
  
      return response;
    } catch (error) {
      console.error('Erro ao buscar lista de suppliers:', error);
      throw error;
    }
};

export const getListaDestination = async () => {
    try {
        const endpoint: string = "/Destination/all";
        const response = await fetchData<Destination>(endpoint, {});
        return response;
    } catch (error) {
        console.error("Erro ao buscar lista de destinos:", error);
        throw error;
    }
};

export const getDestinationById = async (id: number) => {
    try {
        const response = await api.get<DestinationApiResponse>(`/Destination/${id}`);
        return response.data; 
    } catch (error) {
        console.error(`Erro ao buscar destinos com ID ${id}`, error);
        throw error;
    }
};

export const createDestination = async (destination: Destination) => {
    try {
        const response = await api.post<DestinationApiResponse>("/Destination", destination);
        return response.data;
    } catch (error) {
        console.error("Erro ao criar destinos:", error);
        throw error;
    }
};

export const updateDestination = async (id: number, destination: Destination) => {
    try {
        const response = await api.put<DestinationApiResponse>(`/Destination/update/${id}`, destination);
        return response.data;
    } catch (error) {
        console.error(`Erro ao atualizar destinos com ID ${id}:`, error);
        throw error;
    }
};

export const deleteDestination = async (id: number) => {
    try {
        const response = await api.delete(`/Destination/delete/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Erro ao excluir destinos com ID ${id}:`, error);
        throw error;
    }
};
